import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { ModuleGrid, type ModuleCard } from '../common/ModuleGrid';
import {
  HALF_ROW,
} from '../common/moduleCardLayouts';

export default function ReportsHomePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const modules: ModuleCard[] = [
    {
      id: 'net-cash-flow',
      title: 'Рух коштів (Net)',
      description: 'Купівлі, продажі та чистий рух коштів за період',
      icon: TrendingUpIcon,
      path: `/companies/${id}/reports/net-cash-flow`,
      layout: HALF_ROW,
    },
    {
      id: 'net-cash-flow-by-product',
      title: 'Рух коштів по товарах',
      description: 'Розбивка чистого руху коштів по кожному товару',
      icon: BarChartIcon,
      path: `/companies/${id}/reports/net-cash-flow-by-product`,
      layout: HALF_ROW,
    },
    {
      id: 'margin',
      title: 'Маржа',
      description: 'Виручка мінус собівартість проданого товару за період',
      icon: ShowChartIcon,
      path: `/companies/${id}/reports/margin`,
      layout: HALF_ROW,
    },
    {
      id: 'margin-by-product',
      title: 'Маржа по товарах',
      description: 'Розбивка маржі по кожному товару',
      icon: StackedBarChartIcon,
      path: `/companies/${id}/reports/margin-by-product`,
      layout: HALF_ROW,
    },
    {
      id: 'inventory-value',
      title: 'Вартість складу',
      description: 'Звірка вартості складу на початок і кінець періоду',
      icon: Inventory2Icon,
      path: `/companies/${id}/reports/inventory-value`,
      layout: HALF_ROW,
    },
  ];

  return (
    <Box sx={{ p: { xs: 1.5, sm: 3 } }}>
      <Box
        sx={{
          position: 'sticky',
          top: 64,
          zIndex: 10,
          backgroundColor: 'background.default',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
          py: 1,
          mb: 0.5,
        }}
      >
        <Button
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/companies/${id}/home`)}
          size="small"
        >
          На головну
        </Button>
        <Typography
          variant="button"
          component="h1"
          noWrap
          sx={{
            minWidth: 0,
            pr: { xs: '9px', sm: '10px' },
            color: 'primary.main',
          }}
        >
          Звіти
        </Typography>
      </Box>

      <ModuleGrid modules={modules} />
    </Box>
  );
}
